import { CartUpdatedEvent } from '@theme/events';

/**
 * Morfil (mf7) P6 — encart « compléter le pack » du panier (snippet mf7-pack-relance) : un couteau touché est ajouté
 * au panier. Dans le tiroir, le contenu est rendu de nouveau par l'événement natif cart:updated (cart-drawer.js), qui
 * relance aussi l'accord des cadeaux du pack (mf7-pack-panier.js). Sur la page panier, la page se recharge.
 */
class Mf7PackRelance extends HTMLElement {
  connectedCallback() {
    this.onClick = this.onClick.bind(this);
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  async onClick(event) {
    const bouton = event.target.closest('[data-mf7-relance-ajout]');
    if (!bouton || bouton.disabled || this.classList.contains('is-loading')) return;
    event.preventDefault();

    this.classList.add('is-loading');
    bouton.classList.add('is-loading');
    this.erreur('');

    const tiroir = this.closest('cart-drawer');
    let rechargement = false;
    const corps ={ items: [{ id: Number(bouton.dataset.mf7RelanceAjout), quantity: 1 }] };
    if (tiroir?.dataset.sectionId) {
      corps.sections = tiroir.dataset.sectionId;
      corps.sections_url = window.location.pathname;
    }

    try {
      const reponse = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(corps),
      });
      const data = await reponse.json();

      if (!reponse.ok || data.status >= 400 || data.errors) {
        this.erreur(data.description || data.message || 'Ajout impossible pour le moment.');
        return;
      }

      if (!tiroir) {
        // Page panier : cadeaux du pack accordés d'abord, puis un seul rechargement
        rechargement = true;
        try {
          await window.mf7PackAccorder?.({ recharger: false });
        } finally {
          window.location.reload();
        }
        return;
      }

      // Nombre d'articles : relu si possible, sinon le panier natif le recalcule
      let itemCount;
      try {
        itemCount = (await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json())).item_count;
      } catch {
        itemCount = undefined;
      }
      document.dispatchEvent(new CartUpdatedEvent({}, { itemCount, source: 'mf7-pack-relance', sections: data.sections }));
    } catch (error) {
      console.error('mf7-pack-relance : ajout impossible', error);
      this.erreur('Ajout impossible pour le moment.');
    } finally {
      // Dans le tiroir, l'encart est remplacé par le nouveau rendu ; ceci ne sert qu'en cas d'erreur.
      // Page panier : l'état « en cours » reste jusqu'au rechargement.
      if (!rechargement) {
        this.classList.remove('is-loading');
        bouton.classList.remove('is-loading');
      }
    }
  }

  erreur(message) {
    const el = this.querySelector('[data-mf7-relance-erreur]');
    if (!el) return;
    el.textContent = message;
    el.hidden = !message;
  }
}

if (!customElements.get('mf7-pack-relance')) {
  customElements.define('mf7-pack-relance', Mf7PackRelance);
}
